import queryString from 'query-string';
import { DEFAULT_FILTERS } from '../constants/default';
import { getFiltersToStore } from './searchDataUtils';

// Resume: reopen the saved search with the filters stored alongside it. Params take precedence over filters.
export const buildResumeQuery = (params, filters) =>
  queryString.stringify({ ...DEFAULT_FILTERS, ...getFiltersToStore(filters), ...params });

// Start over: reopen the saved search with default filters only.
export const buildStartOverQuery = (params) => queryString.stringify({ ...DEFAULT_FILTERS, ...params });

// Compares two query strings independent of key order.
export const isSameSearchQuery = (a, b) => {
  if (!a || !b) return false;
  return queryString.stringify(queryString.parse(a)) === queryString.stringify(queryString.parse(b));
};
